export const tags = [
  "C++",
  "HTML",
  "CSS",
  "React Native",
  "JavaScript",
  "NodeJS",
  "MongoDB",
  "ReactJS",
  "Git",
  "Github",
  "MySQL",
  "Data Structures",
  "ExpressJS",
  "Algorithms",
  "REST",
];
